<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/emp/resource/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, '40%')" type="primary" v-if="utils.checkPower('web_employment_management_employee_create')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>

      <template #caozuo="scope">
        <el-button size="mini" @click="yt.showEditDialog('bianji', scope.row, 'w1')" type="text">
          {{ $t('bianji') }}
        </el-button>
      </template>
    </yi_curd_table>

    <el-dialog :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" width="50%" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form ref="form" :model="formData" :rules="rules" label-width="auto" size="mini">
          <el-row>
            <el-col :span="8">
              <el-form-item label="工号">
                {{ employee.jobNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名">
                {{ employee.name }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资源类别">
                <yi_dictionary_select size="small" :max="1" :type="'HR_RESOURCE_TYPE'" :ids.sync="formData.resourceType"> </yi_dictionary_select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="选择资源" v-if="formData.resourceType&&formData.resourceType > -1"">
            <yi_cross_select ref="crossSelect_add" :key="componentName()" multiple="ture"   :component="componentName()" :ids.sync="formData.resourceIds"    @change="typeChange"> </yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="saveData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'bianji'">
        <el-form ref="form" :model="formData" :rules="rules" label-width="auto" size="mini">
          <el-row>
            <el-col :span="8">
              <el-form-item label="工号">
                {{ employee.jobNo }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名">
                {{ employee.name }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资源类别">
                <yi_dictionary_select size="small" :max="1" :type="'HR_RESOURCE_TYPE'" :ids.sync="yt.editObj.resourceType" @change="typeChange"> </yi_dictionary_select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="选择资源" v-if="yt.editObj.resourceType&&yt.editObj.resourceType > -1"">
            <yi_cross_select ref="crossSelect_update" multiple="ture"   :key="componentName()" :component="componentName()" :ids.sync="yt.editObj.resourceIds"  @change="typeChange"> </yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="update()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    employee: {
      type: Object,
      default: null
    }
  },

  name: 'reource_table',
  data() {
    return {
      formData: {
        empId: this.employee.id,
        resourceIds:[]
      },
      componentsMap: {
        0: "web_base_equipment_list",
        1: "web_order_management_production_plan_mold_list"
      },
      skillList: [],
      columns: [
        {
          label: 'ziyuanleixing',
          prop: 'resourceType',
          type: 'dictionary',
          key: 'HR_RESOURCE_TYPE'
        },
        {
          label: 'ziyuanbianma',
          prop: 'resourceCode'
        },
        {
          label: 'ziyuanmingcheng',
          prop: 'resourceName',
        },
        {
          label: 'fenpeishijian',
          prop: 'authTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.empId = this.employee.id;
      this.yt.get(1);
    }, 300);
  },
  methods: {

    typeChange(){
        this.$refs.crossSelect_update.setIds([]);
        this.$refs.crossSelect_add.setIds([]);
    },
    componentName() {
      let resourceType = this.formData.resourceType?this.formData.resourceType : this.yt.editObj.resourceType;
      return this.componentsMap[resourceType];
    },
    update() {
      this.http
        .post('/web/emp/resource/update', this.yt.editObj)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.formData = JSON.parse(JSON.stringify({}));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    saveData() {
      if(this.formData.resourceType == null || this.formData.resourceType == -1){
        this.$message.error(this.$t('please_select_resource_type'));
        return;
      }
      if(this.formData.resourceIds.length == 0){
        this.$message.error(this.$t('please_select_resource'));
        return;
      }
    
      this.http
        .post('/web/emp/resource/create', this.formData)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.formData = JSON.parse(JSON.stringify({}));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    close() {
      this.yt.isShowEditDialog = false;
      this.form = {};
    }
  }
};
</script>

<style scoped lang="scss">
.skill-authorization {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.el-form-item {
  margin-bottom: 20px;
}
.days-count {
  color: red;
  margin-left: 10px;
}
</style>
